"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled = __importStar(require("./styled"));
require("rc-slider/assets/index.css");
const useDebounce_1 = __importDefault(require("../../../Hooks/useDebounce"));
var NumberInputs;
(function (NumberInputs) {
    NumberInputs["LEFT"] = "left";
    NumberInputs["RIGHT"] = "right";
})(NumberInputs || (NumberInputs = {}));
const DELAY_TIME = 400;
const RangeInput = ({ min, max, fromValue, setFromValue, toValue, setToValue }) => {
    const debouncedRightValue = (0, useDebounce_1.default)(toValue, DELAY_TIME);
    const debouncedLeftValue = (0, useDebounce_1.default)(fromValue, DELAY_TIME);
    (0, react_1.useEffect)(() => {
        if (debouncedRightValue < fromValue && debouncedRightValue > min) {
            const leftCopy = fromValue;
            const rightCopy = toValue;
            setFromValue(rightCopy);
            setToValue(leftCopy);
        }
        if (debouncedRightValue < fromValue && debouncedRightValue < min) {
            setToValue(max);
        }
    }, [debouncedRightValue]);
    (0, react_1.useEffect)(() => {
        if (debouncedLeftValue < min || debouncedLeftValue > max) {
            setFromValue(min);
        }
    }, [debouncedLeftValue]);
    const onSliderChange = (values) => {
        setFromValue(values[0]);
        setToValue(values[1]);
    };
    const onInputChange = (e, type) => {
        const value = e.target.value;
        if (type === NumberInputs.LEFT && +value <= toValue) {
            setFromValue(+value);
        }
        if (type === NumberInputs.RIGHT && +value <= max) {
            setToValue(+value);
        }
    };
    return (react_1.default.createElement(styled.Container, null,
        react_1.default.createElement(styled.InputContainer, null,
            react_1.default.createElement(styled.Input, { type: "number", value: fromValue, onChange: e => onInputChange(e, NumberInputs.LEFT) }),
            "-",
            react_1.default.createElement(styled.Input, { type: "number", value: toValue, onChange: e => onInputChange(e, NumberInputs.RIGHT) })),
        react_1.default.createElement(styled.RangeInput, { range: true, value: [fromValue, toValue], min: min, max: max, onChange: onSliderChange, allowCross: false, minValue: min === fromValue, maxValue: max === toValue, toAtMin: toValue === min, fromAtMax: fromValue === max })));
};
exports.default = RangeInput;
